import { SUMMARY_PAYMENT_RECEIVED } from "../shared/constants";

const initialSummaryPaymentState = {
	data: {
		thisMonth: 0,
		received: 0,
		feeRecived: 0,
		toReceive: 0,
		feeToReceive: 0,
		totalMonth: 0,
		toReceiveNextMonth: 0
	}
};

export const summaryPayment = (state = initialSummaryPaymentState, action) => {
	switch (action.type) {
		case SUMMARY_PAYMENT_RECEIVED:
			return {
				...state,
				data: action.data
			};

		default:
			return state;
	}
};
